const initialState = {
    closeSession: false,
  };
  
  const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_CLOSE_SESSION':
        return {
          ...state,
          closeSession: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default sessionReducer;